'use client';

export default function ConferenceError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>会议页面渲染出错</h2>
      <pre style={{ textAlign: 'left', whiteSpace: 'pre-wrap', color: 'red' }}>
        {error.message}
        {error.digest && `\n\nDigest: ${error.digest}`}
      </pre>
      <button onClick={() => reset()} style={{ marginTop: 16, padding: '8px 16px' }}>
        重试
      </button>
    </div>
  );
}
